module.exports = __webpack_public_path__ + "img/cat-eats-from-bowl.414e21a5.jpg";